import { findEntryFieldByType } from "../../entryFields";
import type { DynamicStructure, InferParams } from "../types";

/**
 * Resolve um template `{{context.campo|type}}` descobrindo o campo pelo seu tipo
 * via `_metadata` do nó do contexto. `item` e `section` são, como nos demais
 * blocos dinâmicos (ex.: `{{section.titulo|text}}`), o objeto da entry atual.
 * Retorna `undefined` quando não há campo do tipo — o consumidor então aplica o
 * fallback manual. O primeiro campo do tipo é usado quando há mais de um.
 */
export function resolveInferredTemplate(
  structure: DynamicStructure,
  infer: InferParams,
): string | undefined {
  const node = infer.context === "item" ? structure.item : structure.section;
  const field = findEntryFieldByType({ entry: node, type: infer.type });

  return field ? `{{${infer.context}.${field.name}|${infer.type}}}` : undefined;
}
